import { useApplication } from 'merchant-api/unified';
import BankConfirmationCard from '../../../LoanApp/Cards/BankConfirmationCard';
import BankData from './BankData';
import { LoadingAnimation } from '@odmonorepo/core-components';
import { useBankInfo } from 'merchant-api/checkout';

export const BankVerification = () => {
  const { applicationData, isLoadingApplication } = useApplication();
  const { bankInfo, isLoadingBankInfo } = useBankInfo(applicationData?.id);

  if (isLoadingApplication || isLoadingBankInfo || !bankInfo) {
    return <div className='mx-auto'><LoadingAnimation /></div>;
  }
  return bankInfo.bankName ? <BankConfirmationCard /> : <BankData />;
};
